// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:768px){#collection-filter[data-v-5d762ab4]{position:-webkit-sticky;position:sticky;left:0;top:125px;max-height:500px}}.breadcrumbs span[data-v-5d762ab4]{margin-right:1rem;font-size:.75rem;letter-spacing:.1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
